export default {
    setSessionValidity(context, payload) {
        context.commit('setSessionValidity', payload);
    },

    setServerStatus(context, payload) {
        context.commit('setServerStatus', payload);
    },

    appInitialiazed(context, payload) {
        context.commit('appInitialiazed', payload);
    },
    login(context, payload) {
        context.commit('setAuth', payload);

        // if (context.state.cart.cart.length > 0) {
            // If there are any entries in the cart when logging in, recall the web service part.detail for each item in the cart to rebuild pricing
            context.dispatch('cart/rebuildItemPricing', '', { root: true });
        // }
    },

    // reset the values to default
    logout(context,) {
        context.commit('setAuth', {
            isAuth: false,
            userid: '',
            customer: context.state.defaultB2Ccustomer,
            customerIndicator: 'C'
        });
        
        context.commit('setcustomerDefaultCC', {
            savednumber: '',
            last4digits: ''
        });
    },
    
    setUserAttributes(context, payload) {
        context.commit('setUserAttributes', payload);
    },
    setStorefrontAttributes(context, payload) {
        context.commit('setStorefrontAttributes', payload);
    },
    setStoreCatalog(context, payload) {
        context.commit('setStoreCatalog', payload);
    },

    setStoreConfigID(context, payload) {
        context.commit('setStoreConfigID', payload);
    },

    setCustomer(context, payload) {
        context.commit('setCustomer', payload);
    },
    setDefaultB2CCustomer(context, payload) {
        context.commit('setDefaultB2CCustomer', payload);
    },

    setCustomerDetails(context, payload) {
        context.commit('setCustomerDetails', payload);
    },

    resetCustomerDetails(context) {
        context.commit('resetCustomerDetails');
    },

    setDefaultLocationDetails(context, payload) {
        context.commit('setDefaultLocationDetails', payload);
    },

    setPassword(context, payload) {
        context.commit('setPassword', payload);
    },

    setLanguages(context, payload) {
        context.commit('setLanguages', payload);
    },
    
    setErrorFields(context, payload) {
        context.commit('setErrorFields', payload);
    },

    setcustB2BLocations(context, payload) {
        context.commit('setcustB2BLocations', payload);
    },

    setcustInfoEnrolled(context, payload) {
        context.commit('setcustInfoEnrolled', payload);
    },
    
    setmfgs_imgs(context, payload) {
        context.commit('setmfgs_imgs', payload);
    },
    
    setwd_mfgs(context, payload) {
        context.commit('setwd_mfgs', payload);
    },

    setwd_mfgxs(context, payload) {
        context.commit('setwd_mfgxs', payload);
    },

    setStorefront(context, payload) {
        context.commit('setStorefront', payload);
    },

    setcat_img_level_1(context, payload) {
        context.commit('setcat_img_level_1', payload);
    },

    setcustomerDefaultCC(context, payload){
        context.commit('setcustomerDefaultCC', payload);
    },

    setTypahead_str(context, payload) {
        context.commit('setTypahead_str', payload);
    },

    setSolr_hostname(context, payload) {
        context.commit('setSolr_hostname', payload);
    },

    setSolr_coreadmin(context, payload) {
        context.commit('setSolr_coreadmin', payload);
    },

    setSolr_faceted_filter(context, payload) {
        context.commit('setSolr_faceted_filter', payload);
    },

    setCat_faceted_filter(context, payload) {
        context.commit('setCat_faceted_filter', payload);
    },

    setSolr_username(context, payload){
        context.commit('setSolr_username', payload);
    },

    setSolr_password(context, payload){
        context.commit('setSolr_password', payload);
    },

    setSlider_url(context, payload){
        context.commit('setSlider_url', payload);
    },

    setRMA_enabled(context, payload){
        context.commit('setRMA_enabled', payload);
    },

    setDesktop_logo(context, payload){
        context.commit('setDesktop_logo', payload);
    },

    setMobile_logo(context, payload){
        context.commit('setMobile_logo', payload);
    },
}